import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, ForwardedRef } from 'react';
import { WikiPageSearchResult } from '../../../interfaces/wiki/Wiki';

interface InternalLinkSuggestionListProps {
  items: WikiPageSearchResult[];
  command: (item: WikiPageSearchResult) => void;
}

export interface InternalLinkSuggestionListRef {
  onKeyDown: (props: { event: KeyboardEvent }) => boolean;
}

export const InternalLinkSuggestionList = forwardRef((props: InternalLinkSuggestionListProps, ref: ForwardedRef<InternalLinkSuggestionListRef>) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = useCallback((index: number) => {
    const item = props.items[index];
    if (item) {
      props.command(item);
    }
  }, [props]);

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
        return true;
      }
      if (event.key === 'ArrowDown') {
        setSelectedIndex((selectedIndex + 1) % props.items.length);
        return true;
      }
      if (event.key === 'Enter') {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  return (
    <div className="internal-link-suggestion-list">
      {props.items.length > 0 ? (
        props.items.map((item, index) => (
          <button
            type="button"
            className={`internal-link-suggestion-item ${index === selectedIndex ? 'is-selected' : ''}`}
            key={item.id}
            onClick={() => selectItem(index)}
          >
            {item.title}
          </button>
        ))
      ) : (
        <div className="internal-link-suggestion-item">No results</div>
      )}
    </div>
  );
});
